import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import ConfigurationsFinalInterviewDimensionsService from "../../../../services/api/configurations/ConfigurationsFinalInterviewDimensions.service";
import { RefreshReactQuery } from "../../../../constants/AppConstants";
import { useNotification } from "../../../notification.hook";
import {
  DATA_SAVED_SUCCESS_LABEL,
  ERROR_LABEL,
  ERROR_MESSAGE_LABEL,
} from "../../../../constants/Dictionary";
import { UpdateFinalInterviewDimensionsConfig } from "../../../../types/api/configurations.type";
import { useEffect } from "react";

const MANAGE_CONFIG_FINAL_INTERVIEW_QUERY_KEY =
  "get-config-final-interview-dimensions";

export const useManagFinalInterview = (configYear: number) => {
  const { notification } = useNotification();
  const { data, isFetching, isError } = useQuery({
    queryKey: [MANAGE_CONFIG_FINAL_INTERVIEW_QUERY_KEY, configYear],
    queryFn: () => ConfigurationsFinalInterviewDimensionsService.list(),
    staleTime: RefreshReactQuery.MODERATE,
  });

  useEffect(() => {
    if (isError) {
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    }
  }, [isError]);

  return { data, isFetching };
};

export const useUpdateManageFinalInterview = () => {
  const { notification } = useNotification();
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationKey: ["update-manage-final-interview-dimension"],
    mutationFn: (result: UpdateFinalInterviewDimensionsConfig) =>
      ConfigurationsFinalInterviewDimensionsService.update(result),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [MANAGE_CONFIG_FINAL_INTERVIEW_QUERY_KEY],
      });
      notification.success(DATA_SAVED_SUCCESS_LABEL, undefined, "toast");
    },
    onError: (error) => {
      console.error(
        `errore updating final interview dimension config: ${error}`,
      );
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    },
  });

  return { mutate, isPending };
};
